<template>
    <div class="comment">
        <div class="origin">
            
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>